import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';

interface HeaderActionProps {
  handleGoBack: () => void;
  handleSubmit: () => void;
}

function HeaderAction({ handleGoBack, handleSubmit }: HeaderActionProps) {
  return (
    <div className="w-full border-b-1 border-[silver] h-[60px] flex items-center justify-between px-4">
      <button className="px-3 cursor-pointer rounded w-fit h-fit " onClick={handleGoBack}>
        <ArrowLeftOutlined className="text-[20px]" />
      </button>
      <button
        className="px-3 py-2 bg-[#e6f8ff] rounded w-fit h-fit text-[18px] hover:bg-[#d8f0fa]"
        onClick={handleSubmit}
      >
        Lưu
      </button>
    </div>
  );
}

export default HeaderAction;
